import React from "react";
import {
  Grid,
  TableBody,
  TableRow,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { IsEmpty, readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const payuDetails = ({ data }) => {
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item xs={12}>
            PayU Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item xs={12} md={6} lg={6}>
            <table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">PayU Identifier</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["payu_identifier"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Credentials Of</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["credentials_of"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Status</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <BootstrapBadge text={data["status"]} />
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Transaction Datetime</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["transaction_datetime"])}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Bank Reference Identifier</TableBodyCell>
                  <TableBodyCell className="common_table_content"><IsEmpty itemKey={data} value="bank_reference_identifier"></IsEmpty></TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <table className="w-full">
            <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Error Message</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                  <IsEmpty itemKey={data} value="error_message"></IsEmpty>
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Status Code</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                  <IsEmpty itemKey={data} value="status_code"></IsEmpty>
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Status Message</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                  <IsEmpty itemKey={data} value="status_message"></IsEmpty>
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["created_at"])}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Updated At</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["updated_at"])}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
